 export const getCustomerId = (): string | number | undefined => {
    try {
      const saved = localStorage.getItem('userId');
      if (saved) {
        return saved;
      }
    } catch (err) {
 return undefined;    }
    return undefined;
  };


 export  const validateEmail = (value: string) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) return "Email is required";
  if (!regex.test(value)) return "Enter a valid email";
  return "";
};